const enum GenerationStatus {
  NotGenerating = 'NotGenerating',
  Generating = 'Generating',
  Generated = 'Generated',
}

export default GenerationStatus;
